/**
 * Normalize any timestamp shape this module receives into a Date.
 *
 * Sources differ by transport: Firestore SDK gives Timestamp ({toDate()} /
 * {seconds}), the builder REST facade serializes admin Timestamps as
 * {_seconds,_nanoseconds}, and imported/eval documents carry ISO strings or
 * epoch millis. Returns null for anything unparseable — callers render a
 * placeholder instead of "Invalid Date".
 */
export function toDate(value: unknown): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof (value as any)?.toDate === 'function') {
    const date = (value as any).toDate();
    return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
  }
  const seconds = (value as any)?.seconds ?? (value as any)?._seconds;
  if (typeof seconds === 'number') {
    const date = new Date(seconds * 1000);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  return null;
}
